<template>
  <div class="box"> </div>
</template>

<script>
  import API from '../api/login';
  import { MessageBox } from 'element-ui';
  export default {
    name: 'sso',
    mounted() {
      this.getLoginInfo();
    },
    methods: {
      getLoginInfo() {
        const token = this.$route.query.token;
        this.loading.startLoading();
        this.$axios.post('/uaa/sso/login', { token: token }).then((res) => {
          this.$globalVar.refreshTokenFlag = 0;
          if (res.data.code === 0) {
            const user = {
              // 是否是权限系统账号 1是2否
              isAuth: res.data.data.isAuth,
              access_token: res.data.data.token.access_token,
              applicationCode: '',
              account: res.data.data.user.account || '',
              // 账号名称
              userName: res.data.data.user.userName || res.data.data.user.tenantName,
              // 账号id
              userCode: res.data.data.token['X-AUTH-UserId'],
              // 账号是否是管理员
              adminFlag: res.data.data.user.adminFlag || '',
              // 公司编码
              companyCode: '',
              // 公司名称
              companyName: '',
              // 部门编码
              departmentCode: '',
              // 部门名称
              departmentName: '',
              // 租户code
              tenantCode: res.data.data.user.tenantCode || '',
              // 租户名称
              tenantName: res.data.data.user.tenantName || '',
              inoutFlag: res.data.data.user.inoutFlag || '',
              personNo: res.data.data.user.personNo,
              personName: res.data.data.user.personName,
              // 时间戳
              expir: res.data.data.expir,
              // 刷新token
              refresh_token: res.data.data.token.refresh_token,
              password: this.Base64.encode(res.data.data.user.password),
            };
            this.$store.commit('saveUserInfo', user);
            this.$store.dispatch('tagsView/delAllViews');
            // 如果是登录权限系统账号不需要选择应用
            if (res.data.data.isAuth === '1') {
              this.loading.endLoading();
              this.$router.push('/dashboard');
            } else {
              // 获取应用列表
              this.getApplication(user);
              // 获取详情按钮权限
              this.getRoleOtherButton(user);
            }
          } else {
            this.loading.endLoading();
            MessageBox.alert(
              "<div><img src='./static/img/error.png'/><div class='confirmTitle'>" +
                res.data.data +
                '</div>' +
                "<div class='confirmContent'>" +
                '点击按钮跳转到登录页' +
                '</div></div>',
              '',
              {
                dangerouslyUseHTMLString: true,
                center: true,
                confirmButtonText: this.$t('alert.confirm'),
                callback: () => {
                  this.$router.push('/login');
                },
              }
            );
          }
        });
      },
      // 获取应用列表
      getApplication(user) {
        const params = {};
        this.$axios.get(API.GET_APPLICATION_LIST_API + '/' + user.userCode, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            //当前涉及到多应用  多菜单全局中定义固定应用code
            user.applicationCode = this.$globalVar.applicationCode[0];
            this.$store.commit('saveUserInfo', user);
            this.$router.push('/dashboard');
            /* if (res.data.data.length === 1) {
              user.applicationCode = res.data.data[0].applicationCode;
              this.$store.commit("saveUserInfo", user);
              this.$router.push("/dashboard");
            } else {
              // TODO
              this.$alert("该功能暂未开发，敬请期待。");
            } */
          } else {
            // 如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取详情按钮权限
      getRoleOtherButton(user) {
        this.$axios
          .post(API.GET_ROLE_OTHER_BUTTON + '?USER_ACCOUNT=' + user.account)
          .then((res) => {
            if (res.data.code === 0) {
              this.$store.dispatch('authCode/setAuthCode', res.data.data);
            } else {
              // 如果有错误返回，提示信息
              this.$alert('获取按钮权限失败：' + res.data.msg);
              this.$router.push('/login');
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../assets/bg.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
</style>
